import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import LdsImage from "../../components/LdsImage";
import FigureCaption from "../../components/LdsFigureCaption";
import Scans from "../../assets/module-1/Group113.png";
import References from "../../components/References";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_0_4 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section className="mb-5">
            <h1 className="blue text-uppercase b mt-5">
              1.0.4 CERAD Guidelines for Diagnosis
            </h1>
            <p className="mt-3 mb-0">Estimated time to complete: 1 minute</p>
          </section>
          <section className="mb-5 row">
            <div className="col-sm-12 col-md-6">
              <FigureCaption
                noCollapse={true}
                className="figcaption-no-border"
                textContent={
                  <>
                    <p>
                      &copy;2016. Avid Radiopharmaceuticals, Inc. All rights
                      reserved.
                      <br />
                      Data on File, Lilly Research Laboratories: AMY20121001A,
                      AMY20121001B.
                    </p>
                  </>
                }
              >
                <LdsImage
                  src={Scans}
                  alt="Comparison of Amyvid brain scans showing a negative result on the left and a positive result on the right, indicating amyloid plaque presence in the positive scan."
                  style={{ maxWidth: "700px" }}
                  className="blue-rounded-border pt-3 pb-3"
                />
              </FigureCaption>
            </div>
            <div className="col-sm-12 col-md-6">
              <p>
                The CERAD guidelines for postmortem AD diagnosis use an
                algorithm incorporating age, neuritic plaque score, and the
                clinical history of dementia to provide a level of certainty of
                AD diagnosis.<sup>1,2</sup>
              </p>
              <p>
                There are 4 different levels of plaque scores that result from
                neuropathological inspection. They are: none, sparse, moderate,
                and frequent. Moderate and frequent amyloid plaque levels are
                consistent with probable or definite AD neuropathology under the
                modified CERAD criteria.<sup>1,3</sup>
              </p>
              <p>
                For purposes of determining agreement between <em>in vivo</em> Amyvid image results and postmortem, whole brain, amyloid neuritic plaque density, Amyvid results (negative/positive) were prespecified to correspond with specific plaque density scores, based on the modified CERAD criteria.<sup>3</sup> We will discuss further during our review of Amyvid clinical trials.
              </p>
              <p>
                A positive Amyvid scan does not establish a diagnosis of AD or
                other cognitive disorder.
              </p>
              <p className="blue b">
                Appropriate Use Criteria: In 2024 the Alzheimer’s Association
                and Society for Nuclear Medicine and Molecular Imaging updated
                the previous Appropriate Use Criteria for amyloid PET. For more
                information, please see{" "}
                <a
                  className="lds-link"
                  target="_blank"
                  href="https://www.alz.org/media/Documents/AUC-Amyloid-Tau-PET-Alzheimers_Manuscript.pdf"
                  rel="noreferrer"
                >
                  {" "}
                  https://www.alz.org/media/Documents/AUC-Amyloid-Tau-PET-Alzheimers_Manuscript.pdf
                </a>

              </p>
            </div>
          </section>
          <section className="button-control mb-0">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-1/module-1-0-3", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-1/module-1-1-1", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
          <section className="row mt-0 mb-5">
            <p className="fz-sm">
              CERAD=The Consortium to Establish a Registry for Alzheimer's
              Disease.
            </p>
          </section>
          <References>
            <ol className="no-indent fz-sm">
              <li>
                Mirra SS, et al. <em>Neurology.</em> 1991;41(4):479-486.{" "}
              </li>
              <li>
                Mirra SS, et al. <em>Arch Pathol Lab Med.</em>{" "}
                1993;117(2):132-144.{" "}
              </li>
              <li>
                Amyvid (florbetapir F 18 injection) Prescribing Information.
                Lilly USA, LLC.{" "}
              </li>
            </ol>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_1_0_4;
